import React from 'react'
import style from './articles.style'

const DSstandreports = ({ classes }) => {
  return (
    <article className={classes.article}>
      <h2>Основные стандартные отчеты Google Analytics </h2>
      <p>
        Google Analytics имеет большое количество встроенных отчетов, которые
        помогут вам в&nbsp;оптимизации сайта или оптимизации работы
        с&nbsp;рекламными каналами. в&nbsp;этой статье рассмотрим базовые.
      </p>
      <h3>Отчеты “В режиме реального времени” </h3>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nf4mmx.png" alt="true" />
        {/* <figcaption>-</figcaption> */}
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nf4mmx&amp;sa=D&amp;ust=1558095569426000">http://prntscr.com/nf4mmx</a></p> */}
      <h4>В Google Analytics: </h4>
      <p>Отчеты&nbsp;→ в&nbsp;режиме реального времени</p>
      <h4>Что это за отчет и&nbsp;чем он полезен: </h4>
      <p>
        Отчет показывает данные с&nbsp;минимальной задержкой (не дольше 30
        секунд), что позволяет проводить диагностику правильной установки
        счетчика, какие события фиксирует Google Analytics, правильно ли
        настроены цели.
      </p>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nf4n5n.png" alt="true" />
        <figcaption>Фиксация событий</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nf4n5n&amp;sa=D&amp;ust=1558095569427000">http://prntscr.com/nf4n5n</a> (подпись: Фиксация событий)</p> */}
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nf4nb4.png" alt="true" />
        <figcaption>Достижения целей</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nf4nb4&amp;sa=D&amp;ust=1558095569428000">http://prntscr.com/nf4nb4</a> (подпись: Достижения целей)</p> */}
      <h3>Отчет по источникам трафика “Источник/канал” </h3>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nf4nno.png" alt="true" />
        {/* <figcaption>-</figcaption> */}
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nf4nno&amp;sa=D&amp;ust=1558095569428000">http://prntscr.com/nf4nno</a></p> */}
      <h4>В Google Analytics: </h4>
      <p>
        Отчеты&nbsp;→ Источники трафика&nbsp;→ Весь трафик&nbsp;→ Источник/канал
      </p>
      <h4>Что это за отчет и&nbsp;чем он полезен: </h4>
      <ul>
        <li>
          В данном отчете можно понять объем трафика в&nbsp;разрезе по каналам.
          Из него станет понятно, какого качества идет трафик с&nbsp;отдельных
          каналов, как хорошо конвертируется в&nbsp;достижение целей либо
          в&nbsp;продажи и&nbsp;заработанные с&nbsp;них суммы (в случае, если у
          вас настроена электронная коммерция).
        </li>
        <li>
          Чтобы посмотреть такой же отчет в&nbsp;разрезе кампаний/объявлений/
          ключевых слов достаточно выбрать их в&nbsp;качестве основного
          параметра или дополнительного параметра.
        </li>
        <li>
          Для детализации по конкретному каналу достаточно кликнуть по нему
          в&nbsp;стандартной сводке Источник/канал и&nbsp;Google Analytics будет
          показывать общие данные или уточнения через основной
          и&nbsp;дополнительный параметр только в&nbsp;разрезе конкретного
          канала
        </li>
      </ul>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nftv2j.png" alt="true" />
        <figcaption>
          Кампании/объявления/ключевые слова в&nbsp;качестве основного параметра
        </figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nftv2j&amp;sa=D&amp;ust=1558095569429000">http://prntscr.com/nftv2j</a> (подпись: Кампании/объявления/ключевые слова в&nbsp;качестве основного параметра)</p> */}
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nfu3oj.png" alt="true" />
        <figcaption>
          Кампании в&nbsp;качестве дополнительного параметра
        </figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nfu3oj&amp;sa=D&amp;ust=1558095569429000">http://prntscr.com/nfu3oj</a> (подпись: Кампании в&nbsp;качестве дополнительного параметра)</p> */}
      <h3>Отчет по конверсиям “Обзор” </h3>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nfu7lm.png" alt="true" />
        {/* <figcaption>-</figcaption> */}
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nfu7lm&amp;sa=D&amp;ust=1558095569430000">http://prntscr.com/nfu7lm</a></p> */}
      <h4>В Google Analytics: </h4>
      <p>Отчеты&nbsp;→ Конверсии&nbsp;→ Цели&nbsp;→ Обзор</p>
      <h4>Что это за отчет и&nbsp;чем он полезен: </h4>
      <p>
        Помогает быстро понять количество конверсий по всем или отдельной цели.
        Данные можно уточнить по страницам совершения конверсии (и понять, какая
        страница лучше, если это важно) или по каналам.
      </p>
      <h3>Отчеты “Электронная торговля” </h3>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nfugkz.png" alt="true" />
        {/* <figcaption>-</figcaption> */}
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nfugkz&amp;sa=D&amp;ust=1558095569432000">http://prntscr.com/nfugkz</a></p> */}
      <h4>В Google Analytics: </h4>
      <p>Отчеты&nbsp;→ Конверсии&nbsp;→ Электронная торговля</p>
      <h4>Что это за отчет и&nbsp;чем он полезен: </h4>
      <p>
        Помогает быстро понять количество покупок и&nbsp;доход с&nbsp;них.
        в&nbsp;том числе в&nbsp;разрезе по товарам, брендам или категориям
        товаров.
      </p>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nfuhon.png" alt="true" />
        {/* <figcaption>-</figcaption> */}
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nfuhon&amp;sa=D&amp;ust=1558095569433000">http://prntscr.com/nfuhon</a></p> */}
      <h3>
        Отчет по многоканальным взаимодействиям “Ассоциированные конверсии”{' '}
      </h3>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nfuiq9.png" alt="true" />
        {/* <figcaption>-</figcaption> */}
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nfuiq9&amp;sa=D&amp;ust=1558095569433000">http://prntscr.com/nfuiq9</a></p> */}
      <h4>В Google Analytics: </h4>
      <p>
        Отчеты&nbsp;→ Конверсии&nbsp;→ Многокональные последовательности&nbsp;→
        Ассоциированные конверсии
      </p>
      <h4>Что это за отчет и&nbsp;чем он полезен: </h4>
      <p>
        Полезен для тех, кто понимает, что продажи/заявки/звонки с&nbsp;его
        сайта в&nbsp;редких случая происходят после первого же захода
        на&nbsp;сайт. в&nbsp;такой ситуации важно понимать, какие каналы
        привлечения посетителей принимают участие в&nbsp;пути до конверсии
        (чтобы избежать ситуации резкого снижения заявок после отключения
        платного канала, который не приносил конверсий по последнему посещению
        на&nbsp;сайт, но по факту давал большое число эффективных заходов,
        которые в&nbsp;дальнейшем и&nbsp;с помощью другого канала
        покупали/звонили/оставляли заявки). Данный отчет покажет сравнение
        количества конверсий по последнему сеансу (когда пользователь пришел
        с&nbsp;ya.direct и&nbsp;купил&nbsp;– конверсия засчитана ya.direct)
        и&nbsp;ассоциированных конверсий (до того как перейти по объявлению
        ya.direct пользователь натыкался на&nbsp;баннер Google Ads, переходил по
        нему, но отвлекся и&nbsp;не завершил покупку&nbsp;– ассоциированная
        конверсия засчитана google ads и&nbsp;другим вспомогательным каналам).
      </p>
      <h3>
        Отчет по многоканальным последовательностям “Основные пути конверсии”{' '}
      </h3>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nfuonj.png" alt="true" />
        {/* <figcaption>-</figcaption> */}
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nfuonj&amp;sa=D&amp;ust=1558095569435000">http://prntscr.com/nfuonj</a></p> */}
      <h4>В Google Analytics: </h4>
      <p>
        Отчеты&nbsp;→ Конверсии&nbsp;→ Многокональные последовательности&nbsp;→
        Основные пути конверсии
      </p>
      <h4>Что это за отчет и&nbsp;чем он полезен: </h4>
      <p>
        В отчетах по многокальным последовательностям важно учитывать период
        ретроспективного анализа.Эта настройка отвечает за то, сколько дней
        после сеанс новые посещения будут учитывать в&nbsp;рамках одной
        многоканальной последовательности. По умолчанию она установлена
        на&nbsp;30 дней. Это означает, что ассоциированная конверсия не будет
        засчитана для канала с&nbsp;которого пользователи не совершают целевого
        действия и&nbsp;возвращаются на&nbsp;сайт для завершения покупки только
        через 2 месяца.
      </p>
      <figure className={classes.helpArticleFigure}>
        <img src="/images/nfuq25.png" alt="true" />
        <figcaption>Период ретроспективного анализа</figcaption>
      </figure>
      {/* <p>Скриншот: <a href="https://www.google.com/url?q=http://prntscr.com/nfuq25&amp;sa=D&amp;ust=1558095569435000">http://prntscr.com/nfuq25</a> (подпись: Период ретроспективного анализа)</p> */}
    </article>
  )
}

export default style(DSstandreports)
